import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { BillingRoutingModule } from './billing-routing.module';
import { BillingListComponent } from './billing-list/billing-list.component';
import {CoreModule} from '../../core/core.module';
import {CheckboxModule} from 'primeng/primeng';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    BillingRoutingModule,
    DropdownModule,
    FormsModule,
    NgbModule,
    CoreModule,
    CheckboxModule,
    TranslateModule
  ],
  declarations: [
    BillingListComponent
  ]
})
export class BillingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing.module.ts